module.exports = __webpack_public_path__ + "img/scene2.ab02df21.png";